export default {
  all: [],
  current: {
    name: undefined,
    domains: [],
  },
  pagination: {
    offset: 0,
    limit: 10,
    total: undefined,
    currentPage: undefined,
    totalPages: undefined,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/domain-groups/state.js